import axiosInstance from "../../../services/config/axiosinstance";
import { urlBaseAccreditation } from './../../config/index';
import ZebraTagModel from './../../../models/ZebraTagModel';

export default async function updateTag(tag = ZebraTagModel()) {
  try {
    const _config = {
      url: `${urlBaseAccreditation}/zebraTagCode/updateZebraTagCode`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        id: tag.id,
        description: tag.description,
        zebraCode: tag.zebraCode
      }
    };
    const _ret = await axiosInstance(_config);

    if (!_ret.data.success) {
      throw new Error(_ret.data.message);
    }

    return _ret.data.data;
  } catch (error) {
    console.log('Error updateTag', error);
    throw error;
  }
}
